import { Component, h } from 'preact';
import Store from 'store/store';
import * as jsonPointer from 'utils/jsonPointer';

import Toggle from 'components/toggle/toggle';

// import s from 'components/editor/settings/toggleField.sss';

export default class ToggleField extends Component {
	constructor(props) {
		super(props);

		this.onInput = this.onInput.bind(this);
	}

	onInput(e) {
		this.props.onInput?.(e);
		if (!this.props.path) return;
		jsonPointer.setDeep(Store.get().data, this.props.path, e.target.checked);
	}

	render(props) {
		const { children, path, onInput, defaultValue, ...otherProps } = props;
		const checked = path ? (jsonPointer.get(Store.get().data, path) ?? defaultValue) : undefined;
		return <Toggle checked={checked} {...otherProps} onInput={this.onInput}>{children}</Toggle>;
	}
}
